import { render, staticRenderFns } from "./advoriginData.vue?vue&type=template&id=a49f6a14&"
import script from "./advoriginData.vue?vue&type=script&lang=js&"
export * from "./advoriginData.vue?vue&type=script&lang=js&"
import style0 from "./advoriginData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a49f6a14')) {
      api.createRecord('a49f6a14', component.options)
    } else {
      api.reload('a49f6a14', component.options)
    }
    module.hot.accept("./advoriginData.vue?vue&type=template&id=a49f6a14&", function () {
      api.rerender('a49f6a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/advoriginData.vue"
export default component.exports